var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.25,
    y: 25.25,
    width: 27.5,
    height: 24.5,
    rx: 4.25,
    transform: "rotate(-180 28.25 25.25)",
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 15.5857L20.4001 9.29251C20.7657 8.9025 21.3601 8.9025 21.7258 9.29251C22.0914 9.68252 22.0914 10.3165 21.7258 10.7065L15.1629 17.7067C14.7972 18.0978 14.2028 18.0978 13.8371 17.7067L7.27424 10.7065C6.90859 10.3165 6.90859 9.68252 7.27424 9.29251C7.63988 8.9025 8.2343 8.9025 8.59995 9.29251L14.5 15.5857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.550d375f21f9769a30ba4897d4d4f866.svg";
export { ForwardRef as ReactComponent };